import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Componente para habilitar la navegación con gestos en Mac (swipe back)
 * Este componente no renderiza nada visible, solo añade el comportamiento
 */
const SwipeNavigation = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Esta función ayuda a configurar los eventos necesarios para capturar los gestos
    const setupSwipeNavigation = () => {
      // Configurar el historial del navegador para responder al gesto de swipe back
      window.addEventListener('popstate', (event) => {
        console.log('Navegación detectada:', window.location.pathname);
        // React Router debería manejar esto automáticamente gracias al BrowserRouter
      });

      // Opcionalmente, podemos mejorar la experiencia con soporte para gestos horizontales
      // Esto captura el gesto de deslizar horizontalmente en dispositivos táctiles
      let touchStartX = 0;
      let touchEndX = 0;
      
      // Registrar donde inicia el toque
      window.addEventListener('touchstart', (event) => {
        touchStartX = event.changedTouches[0].screenX;
      }, { passive: true });
      
      // Registrar donde termina el toque y decidir si fue un gesto de navegación
      window.addEventListener('touchend', (event) => {
        touchEndX = event.changedTouches[0].screenX;
        handleSwipeGesture();
      }, { passive: true });
      
      // Decidir si el gesto debe considerarse una navegación hacia atrás
      const handleSwipeGesture = () => {
        // Si el gesto fue de izquierda a derecha (>100px) considerarlo navegación atrás
        if (touchEndX - touchStartX > 100) {
          console.log('Gesto de navegación hacia atrás detectado');
          navigate(-1); // Navegar hacia atrás
        }
      };
    };

    setupSwipeNavigation();
    
    // Limpiar eventListeners al desmontar
    return () => {
      window.removeEventListener('popstate', () => {});
      window.removeEventListener('touchstart', () => {});
      window.removeEventListener('touchend', () => {});
    };
  }, [navigate]);

  // Este componente no renderiza nada visible
  return null;
};

export default SwipeNavigation;
